import { TelegramSenderLayout } from "../TelegramSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { TelegramSenderRouterProps } from "../TelegramSenderRouterProps";
import { TelegramSenderEntities } from "../TelegramSenderEntities";
import { NamirasoftMap } from "namirasoft-site-map";

export interface SentListPageProps extends NSARouterMakerResult, TelegramSenderRouterProps
{ }

function SentListPage(props: SentListPageProps)
{
	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<TelegramSenderLayout {...props}
			action={{
				title: "Report",
				description: "View detailed reports of the messages sent, including chat id, message_thread_id, message, date, and time.",
				menus: {}
			}}
			pages={{
				entity: TelegramSenderEntities.sent(props),
				list: {
					ui: {
						search_box: {
							exclude: {
								load_value: (table, column) =>
								{
									if (namirasoft.telegram_sender.tables.sent.name === table)
									{
										let columns = [
											namirasoft.telegram_sender.tables.sent.columns.message.name,
											namirasoft.telegram_sender.tables.sent.columns.result.name,
										]
										return columns.includes(column);
									}
									return false;
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</TelegramSenderLayout>
	);
}

export default SentListPage;